window.onDomLoad(($dom) => {
  // Early return when updated DOM doesn't contain head
  if ($dom.find('head').length === 0) return

  let color = ''

  switch (document.body.dataset.environment) {
    case 'development':
      color = 'limegreen'
      break
    case 'staging':
      color = 'deepskyblue'
      break
    case 'test':
      color = 'red'
      break
    default:
      return
  }

  const favicon = document.head.querySelector(
    'link[rel*="icon"]'
  ) as HTMLLinkElement

  if (!favicon) {
    return
  }

  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.src = favicon.href

  img.onload = function (): void {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    if (!ctx) {
      return
    }

    canvas.width = img.width
    canvas.height = img.height

    const padding = 0.1
    const borderLength = canvas.width * (1 - 2 * padding)
    const borderThickness = canvas.height / 8.0

    ctx.drawImage(img, 0, 0)
    ctx.fillStyle = color

    // fillRect(x, y, w, h)
    ctx.fillRect(
      canvas.width * padding,
      canvas.width - borderThickness,
      borderLength,
      borderThickness
    )

    const link = document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = canvas.toDataURL('image/x-icon')

    // Only remove favicon if it's still a child of document.head
    if (favicon.parentNode === document.head) {
      document.head.removeChild(favicon)
    }
    document.head.appendChild(link)
  }
})
